import { onUnmounted } from '@vue/composition-api'
import store from '@/store/index'

// eslint-disable-next-line import/prefer-default-export
export function registerStore(moduleName, module) {
  if (!store.hasModule(moduleName)) store.registerModule(moduleName, module)
  onUnmounted(() => {
    if (store.hasModule(moduleName)) store.unregisterModule(moduleName)
  })
}
